import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { User, UserDraft } from '../types/user';

export const getMe = (config: ApiConfig) => (): Promise<User> =>
  fetchWrapper<User>(
    `${config.endpoint}user/me`,
    {
      method: 'GET',
    },
    config
  );

export const updateMe =
  (config: ApiConfig) =>
  (data: UserDraft): Promise<User> =>
    fetchWrapper<User>(
      `${config.endpoint}user/me`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
      config
    );

export const getAuthToken = (config: ApiConfig) => (): Promise<{ 'X-AuthToken': string }> =>
  fetchWrapper<{ 'X-AuthToken': string }>(
    `${config.endpoint}user/authtoken`,
    {
      method: 'GET',
    },
    config
  );

export const resetAuthToken = (config: ApiConfig) => (): Promise<{ 'X-AuthToken': string }> =>
  fetchWrapper<{ 'X-AuthToken': string }>(
    `${config.endpoint}user/authtoken`,
    {
      method: 'PUT',
    },
    config
  );
